export default __webpack_public_path__ + "static/media/Path 95.802ee597.svg";